module.exports = __webpack_public_path__ + "img/no-avatar-1.5af922e0.png";